import React from 'react';
function Icon({ className }) {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "9", height: "9", fill: "none", viewBox: "0 0 9 9", className: className },
        React.createElement("mask", { id: "path-1-inside-1_17_199", fill: "#fff" },
            React.createElement("rect", { width: "8.5", height: "8.5", x: "0.25", rx: "1" })),
        React.createElement("rect", { width: "8.5", height: "8.5", x: "0.25", stroke: "currentColor", strokeWidth: "3", mask: "url(#path-1-inside-1_17_199)", rx: "1" })));
}
export const Ad = ({ active }) => (React.createElement("span", { "aria-hidden": "true", className: `navbar-ad-wrapper ${active ? 'active' : ''}` },
    React.createElement("span", { className: "navbar-ad-icon-wrapper" },
        React.createElement(Icon, { className: "ad-square-one" }),
        React.createElement(Icon, { className: "ad-square-two" }),
        React.createElement(Icon, { className: "ad-square-three" }),
        React.createElement(Icon, { className: "ad-square-four" }))));
